<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

$( "#HeaderNavigation ul.list-menu li ul.header__submenu li.menu-lv-2" ).hover(
  function() {
   var menu_img = $( this ).data('img');
    var menu_id = $( this ).data('menu-id');
    var menu_title =$( this ).data('menu-title'); 
    var have_submenu = $( this ).data('child');  
   
    if(have_submenu == false)
    {
        var menu_string = '<img src="'+menu_img+'">';
        $('.nav-submenu-image-'+menu_id).html(menu_string +"<p>"+menu_title+"<p>");
        $('.nav-submenu-image-'+menu_id).css("opacity","1");
        $('.nav-submenu-image-'+menu_id).css("display","block");
    }
    
  }, function() {
    var menu_img = $( this ).data('img');
    var menu_id = $( this ).data('menu-id');
    var menu_string = '<img src="'+menu_img+'">';
    $('.nav-submenu-image-'+menu_id).html("");
    $('.nav-submenu-image-'+menu_id).css("opacity","0");
    $('.nav-submenu-image-'+menu_id).css("display","none");
  }
);
$( ".follow__title.w-inline-block" ).hover(
  function() {
    var bg_color = $( this ).data('color');
    $('body').css("background-color","#"+bg_color);
   
    
  }, function() {
    
    $('body').css("background-color","#fff");
  }
);


//$(document).ready(function(){
//  var variant_text = $( ".product-form__swatch .product-form__radio:checked+.product-form__label .swatch-hover-flex" ).html();
  
//  $(".variant-discription-flex").html(variant_text);
//});

//$( "variant-radios .product-form__label" ).hover(
//     function() {
   
//      var variant_text = $(this).children('.swatch-hover-flex').html();
//      $(".variant-discription-flex").html(variant_text);
    
//  }, function() {
    
   
 // }
//);
<!----Collection page : add position fixed on scroll------>
if ($('#halo-sidebar').length > 0) {
    var fixmeTop = $('#halo-sidebar').offset().top;       // get initial position of the element
    
    $(window).scroll(function() {                  // assign scroll event listener
    
        var currentScroll = $(window).scrollTop(); // get current position
    
        if (currentScroll >= fixmeTop) {           // apply position: fixed if you
            $('#halo-sidebar').addClass("fixed-sidebar");
        } else {                                   // apply position: static
            $('#halo-sidebar').removeClass("fixed-sidebar");
        }
    
    });
}
  
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
